/**
 * Fout van een API-aanroep, met de uitleg uit de response-body apart bewaard.
 *
 * `message` houdt de bestaande vorm ("API request failed: 400 Bad Request - <uitleg>"),
 * zodat code die daarop matcht blijft werken. `detail` bevat alleen de uitleg, zodat een
 * scherm die aan `translateBackendMessage` kan geven zonder eerst te moeten parsen.
 */
export class ApiError extends Error {
  readonly status: number;
  readonly detail?: string;

  constructor(message: string, status: number, detail?: string) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.detail = detail;

    // tsconfig compileert naar ES5, en dan verliest een subclass van een ingebouwde
    // klasse zijn prototype-keten: zonder deze regel is `err instanceof ApiError` false.
    Object.setPrototypeOf(this, ApiError.prototype);
  }
}
